import { magic_path } from '@Api';
import { EntityVersioning, MagicPath, Nullable } from '@Models';
import { inject, injectable } from 'inversify';
import { TYPES } from '@Types';
import { MagicSpellMapper } from './MagicSpellMapper';
import { IMapper } from '@Mapper/IMapper';

@injectable()
export class MagicPathMapper
  implements IMapper<number, magic_path, magic_path, MagicPath>
{
  @inject(TYPES.Mapper.MagicSpellMapper)
  private _spellMapper!: MagicSpellMapper;

  map(item: magic_path): MagicPath {
    return {
      id: item.id,
      name: item.name ?? '',
      icon: item.medium_icon,
      logo: item.medium_logo,
      spells: item.spells.map((spell) => this._spellMapper.map(spell)),
    } satisfies MagicPath as MagicPath;
  }

  mapFull(item: magic_path): MagicPath {
    return this.map(item);
  }

  mapVersioning(data: any): Nullable<EntityVersioning<number>> {
    return null;
  }
}
